import { jsx as U } from "react/jsx-runtime";
import { useState as b, useEffect as j } from "react";
import { useController as y } from "react-hook-form";
import { TEST_IDS as D } from "./testIds.mjs";
import { TextField as M } from "./index53.mjs";
const P = "mui-auto-fill", R = "mui-auto-fill-cancel", K = ({
  control: g,
  name: e,
  defaultValue: r,
  rules: h,
  shouldUnregister: T,
  trimOnChange: S,
  fullWidth: x = !0,
  size: E = "small",
  helperText: C,
  labelType: F = "inside",
  label: V,
  value: i,
  onChange: l,
  onBlur: s,
  InputProps: _ = {},
  InputLabelProps: m = {},
  ...v
}) => {
  const {
    field: { onChange: A, onBlur: B, value: u, ref: I, ...L },
    fieldState: { error: c }
  } = y({
    name: e,
    control: g,
    rules: h,
    defaultValue: r,
    shouldUnregister: T
  }), [f, o] = b(!!r), a = i !== void 0 ? i : u, N = (t) => {
    const d = t.target.value, p = d.trim();
    if (S && p !== d) {
      const { selectionStart: n } = t.target;
      t.target.value = p, typeof n == "number" && t.target.setSelectionRange(
        n,
        Math.max(n - 1, 0)
      );
    }
    A(t), l && l(t);
  }, H = (t) => {
    B(), s && s(t);
  }, k = (t) => {
    t.animationName === P && o(!0), t.animationName === R && o(!1);
  };
  return j(() => {
    const t = !!a;
    t !== f && o(t);
  }, [u, a]), /* @__PURE__ */ U(
    M,
    {
      id: e,
      fullWidth: x,
      size: E,
      error: !!c,
      label: V,
      labelType: F,
      helperText: C || c?.message,
      "data-testid": D.textInput,
      ...v,
      ...L,
      name: e,
      InputProps: {
        onAnimationStart: k,
        ..._
      },
      InputLabelProps: f ? { shrink: !0, ...m } : m,
      ref: I,
      value: a ?? "",
      onChange: N,
      onBlur: H
    }
  );
};
export {
  K as FormTextField
};
//# sourceMappingURL=index10.mjs.map
